import { api } from "../../services/Api";

interface ICheckAuthorization {
    strict: boolean;
    userId?: number;
}

const checkAuthorization = async (props: ICheckAuthorization): Promise<boolean> => {
    const response = await api.get("api/islogged");

    if (response.status === 200) {
        const result = await response.data;
        const isLoggedIn = true;
        const userId = result.userId || 0;

        if (props.strict) {
            return isLoggedIn && userId === props.userId;
        } else {
            return isLoggedIn;
        }
    }

    return false;
};

export default checkAuthorization;
